export enum StudyRequestStatusEnum {
    New = 'New',
    IPDProvided = 'IPDProvided',
}
